// Retry windows come from the server; browser state only preserves their display.
export const retryAfterSeconds = (action = {}) => {
  const payload = action.payload || action;
  const body = payload.message || payload;
  const candidates = [payload.retry_after, body?.error?.retry_after, body?.retry_after];
  for (const value of candidates) {
    if (value === null || value === undefined || value === '') continue;
    const seconds = Number(value);
    if (Number.isFinite(seconds) && seconds >= 0) return Math.ceil(seconds);
  }
  return null;
};

export const authWaitMessage = (action, fallback = 'Too many attempts. Please try again later.') => {
  const seconds = retryAfterSeconds(action);
  return seconds === null ? fallback : `Too many attempts. Try again in ${seconds} seconds.`;
};

const keyFor = challenge => challenge ? `beauti:otp-retry:${challenge}` : null;

export const rememberOtpWait = (challenge, seconds) => {
  const until = Date.now() + seconds * 1000;
  try {
    const key = keyFor(challenge);
    if (key) sessionStorage.setItem(key, String(until));
  } catch (_) { /* Storage denial must not prevent server-authoritative auth. */ }
  return until;
};

export const otpWaitDeadline = (data = {}) => {
  try {
    const key = keyFor(data.challenge_id);
    const stored = key && sessionStorage.getItem(key);
    // Retain expired deadlines too: an old relative payload must not restart it.
    if (stored !== null && Number.isFinite(Number(stored))) return Number(stored);
  } catch (_) { /* The current mounted screen still displays its server wait. */ }
  const seconds = retryAfterSeconds({ retry_after: data.otp_retry_after });
  return seconds === null ? 0 : Date.now() + seconds * 1000;
};
